<template>
  <div class="inline-select">
    <span class="select-value" :id="id+'-label'" :class="{'interactive': isInteractive}">{{selectValue}}</span>
    <select ref="selectEl" :id="id" @change="(val) => selectValue = val" v-if="isInteractive">
      <option v-for="option in sortedOptions" :key="option.id" :value="option.value">{{option.label}}</option>
    </select>
  </div>
</template>

<script>
export default {
  name: "InlineSelect",
  props: ['id', 'options'],
  data () {
    let sortedOptions
    if(this.options){
      sortedOptions = [...this.options].sort((a, b) => a.label < b.label ? -1 : 1)
      let first = sortedOptions.findIndex((d)=>d.value==='commerce-sector-total' || d.value==='')
      if(first>=0) sortedOptions = [sortedOptions[first]].concat(sortedOptions.filter((d,i)=>i!==first))
    } 
    return {
      // TODO: Este tiene que ser el valor por defecto ("todos los comercios")
      selectValue: this.options && this.options[0] && this.options[0].label,
      isInteractive: this.options && this.options.length > 1,
      sortedOptions: sortedOptions
    }
  },
  mounted () {
  },
  methods: {
    // updateSelect (val) {
    //   this.selectValue = this.options && this.options.find(e => e.value == val).label
    // }
  }
}
</script>

<style lang="stylus">
.inline-select
  position relative
  display inline-block
  margin-right vw(5px)
  .select-value
    min-width 40px
    m-font-size(20,32)
    font-family 'Georgia'
    font-style italic
    .desktop &
      m-font-size(26,36)
    &.interactive
      text-decoration underline
      background-image url('~@/assets/icons/arrow-blue.svg')
      background-size vw(12px)
      background-position center right
      background-repeat no-repeat
      padding-right vw(18px)
  select
    position absolute
    top 0px
    left 0px
    opacity 0
    height vh(32px)
    width 100%
    height 100%
    background: transparent;
    border: none;

</style>